// NEXT_PUBLIC_* переменные подставляются бандлером только при литеральном
// доступе вида process.env.NEXT_PUBLIC_XXX на этапе сборки. Вычисляемый
// доступ process.env[ключ] в клиентском бандле вернёт undefined.
// Поэтому все ключи перечислены здесь литерально, а getEnvValue читает
// из этого словаря.
const env = {
  // COMMON
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  MAX_LINK: process.env.NEXT_PUBLIC_MAX_LINK,
  API_CLIENT_ID: process.env.NEXT_PUBLIC_API_CLIENT_ID,
  API_CLIENT_SECRET: process.env.NEXT_PUBLIC_API_CLIENT_SECRET,
  BRANDSIDE_SERVICE_URL: process.env.NEXT_PUBLIC_BRANDSIDE_SERVICE_URL,
  PAGE_REVALIDATE_TIME: process.env.NEXT_PUBLIC_PAGE_REVALIDATE_TIME,
  MAX_BOT_URL: process.env.NEXT_PUBLIC_MAX_BOT_URL,

  // DOMAINS
  MKTU_LANDING_DOMAINS: process.env.NEXT_PUBLIC_MKTU_LANDING_DOMAINS,
  SITE_DOMAINS: process.env.NEXT_PUBLIC_SITE_DOMAINS,
  ONLINE_SEARCH_DOMAINS: process.env.NEXT_PUBLIC_ONLINE_SEARCH_DOMAINS,
  WEB_APP_DOMAINS: process.env.NEXT_PUBLIC_WEB_APP_DOMAINS,
  WEB_APP_PROTOCOL: process.env.NEXT_PUBLIC_WEB_APP_PROTOCOL,
  WHEEL_OF_FORTUNE_DOMAINS: process.env.NEXT_PUBLIC_WHEEL_OF_FORTUNE_DOMAINS,
  WHEEL_OF_FORTUNE_PROTOCOL: process.env.NEXT_PUBLIC_WHEEL_OF_FORTUNE_PROTOCOL,
  WHEEL_WIDGET_DELAY: process.env.NEXT_PUBLIC_WHEEL_WIDGET_DELAY,

  // COMMON FEATURE FLAGS / METRIKA
  WITH_YANDEX_METRIKA: process.env.NEXT_PUBLIC_WITH_YANDEX_METRIKA,
  YANDEX_METRIKA_COUNTER: process.env.NEXT_PUBLIC_YANDEX_METRIKA_COUNTER,
  WITH_CALLTOUCH: process.env.NEXT_PUBLIC_WITH_CALLTOUCH,
  WITH_SETTINGS_THEME: process.env.NEXT_PUBLIC_WITH_SETTINGS_THEME,
  ONLINE_PAYMENT_ENABLED: process.env.NEXT_PUBLIC_ONLINE_PAYMENT_ENABLED,
  EXTENSION_OF_RIGHTS_ENABLED:
    process.env.NEXT_PUBLIC_EXTENSION_OF_RIGHTS_ENABLED,
  USER_DOCUMENTS_ENABLED: process.env.NEXT_PUBLIC_USER_DOCUMENTS_ENABLED,
  PROMOCODE_ENABLED: process.env.NEXT_PUBLIC_PROMOCODE_ENABLED,
  ONBOARDING_ENABLED: process.env.NEXT_PUBLIC_ONBOARDING_ENABLED,

  // SITE
  SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
  SITE_AUTHORIZATION_TOKEN: process.env.NEXT_PUBLIC_SITE_AUTHORIZATION_TOKEN,
  SITE_YANDEX_MAP_API_KEY: process.env.NEXT_PUBLIC_SITE_YANDEX_MAP_API_KEY,
  SEARCH_LANDING_SITE_URL: process.env.NEXT_PUBLIC_SEARCH_LANDING_SITE_URL,
  MKTU_LANDING_SITE_URL: process.env.NEXT_PUBLIC_MKTU_LANDING_SITE_URL,
  SITE_YANDEX_METRIKA_COUNTER:
    process.env.NEXT_PUBLIC_SITE_YANDEX_METRIKA_COUNTER,
  SITE_RECAPTCHA_KEY: process.env.NEXT_PUBLIC_SITE_RECAPTCHA_KEY,
  SITE_NEW_YEAR_THEME: process.env.NEXT_PUBLIC_SITE_NEW_YEAR_THEME,

  // SITE FEATURE FLAGS
  SITE_WITH_REVIEW_WIDGET: process.env.NEXT_PUBLIC_SITE_WITH_REVIEW_WIDGET,
  SITE_WITH_YANDEX_METRIKA: process.env.NEXT_PUBLIC_SITE_WITH_YANDEX_METRIKA,
  SITE_WITH_GOOGLE_TAG_MANAGER:
    process.env.NEXT_PUBLIC_SITE_WITH_GOOGLE_TAG_MANAGER,
  SITE_WITH_CALLTOUCH: process.env.NEXT_PUBLIC_SITE_WITH_CALLTOUCH,
  SITE_WITH_AMO_METRIKA: process.env.NEXT_PUBLIC_SITE_WITH_AMO_METRIKA,

  // SITE CALCULATOR
  SITE_CALCULATOR_TAX_FOR_SUBMITTING:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_TAX_FOR_SUBMITTING,
  SITE_CALCULATOR_MKTU_CLASS_PRICE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_MKTU_CLASS_PRICE,
  SITE_CALCULATOR_MKTU_WORD_PRICE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_MKTU_WORD_PRICE,
  SITE_CALCULATOR_TAX_FOR_ISSUANCE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_TAX_FOR_ISSUANCE,
  SITE_CALCULATOR_MKTU_CLASS_ISSUANCE_PRICE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_MKTU_CLASS_ISSUANCE_PRICE,
  SITE_CALCULATOR_TARIFF_SELF:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_TARIFF_SELF,
  SITE_CALCULATOR_TARIFF_OPTIMAL:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_TARIFF_OPTIMAL,
  SITE_CALCULATOR_TARIFF_ALL_INCLUSIVE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_TARIFF_ALL_INCLUSIVE,
  SITE_CALCULATOR_TARIFF_WITH_GUARANTEE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_TARIFF_WITH_GUARANTEE,
  SITE_CALCULATOR_ACCELERATED_SERVICE_PRICE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_ACCELERATED_SERVICE_PRICE,
  SITE_CALCULATOR_ACCELERATED_TAX_WORD:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_ACCELERATED_TAX_WORD,
  SITE_CALCULATOR_ACCELERATED_TAX_IMAGE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_ACCELERATED_TAX_IMAGE,
  SITE_CALCULATOR_ACCELERATED_TAX_COMBINE:
    process.env.NEXT_PUBLIC_SITE_CALCULATOR_ACCELERATED_TAX_COMBINE,
} satisfies Record<string, string | undefined>

export type EnvKey = keyof typeof env

export function parseBoolean(key: EnvKey) {
  return getEnvValue(key) === 'true'
}

export function parseNumber(key: EnvKey, defaultValue?: number) {
  const value = Number(getEnvValue(key))
  return Number.isFinite(value) ? value : defaultValue
}

export function getEnvValue(key: EnvKey) {
  return env[key]
}
